import React, { PropsWithChildren } from 'react'

const TableOptions: React.FC <PropsWithChildren> = ({ children }) => {

    return <div className = "tableOptions">{children}</div>

}

export default TableOptions